document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.text-video-item');
  const modal = document.querySelector('.text-video-modal');

  if (trigger && modal) {
    const media = modal.querySelector('.text-video-media');
    const url = trigger.dataset.video;

    media.innerHTML = url.endsWith('.mp4')
      ? `<video controls autoplay><source src="${url}" type="video/mp4"></video>`
      : `<iframe src="${url}" allowfullscreen></iframe>`;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  if (
    e.target.classList.contains('text-video-close') ||
    e.target === modal
  ) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.querySelector('.text-video-media').innerHTML = '';
  }
});
